module.exports = __webpack_public_path__ + "img/ennetix-teams-tab.acbddc7d.png";